module.exports = __webpack_public_path__ + "static/Canela-BoldItalic-f1d9e422cc35aa48c1dede88302d4d22.otf";